/**
 * @generated SignedSource<<22434cf12bde86d52ec13d5ab174fdab>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type MeasurementAssetKind = "hydrant" | "valve" | "general_asset" | "%future added value";
export type MeasurementDataKind = "number" | "percentage" | "text" | "%future added value";
export type updatePageMeasurementTemplateQuery$variables = {
  measurementTemplateId: string;
};
export type updatePageMeasurementTemplateQueryVariables = updatePageMeasurementTemplateQuery$variables;
export type updatePageMeasurementTemplateQuery$data = {
  readonly measurementTemplate: {
    readonly id: string;
    readonly createdAt: any;
    readonly name: string;
    readonly dataKind: MeasurementDataKind;
    readonly assetKind: MeasurementAssetKind;
  } | null;
};
export type updatePageMeasurementTemplateQueryResponse = updatePageMeasurementTemplateQuery$data;
export type updatePageMeasurementTemplateQuery = {
  variables: updatePageMeasurementTemplateQueryVariables;
  response: updatePageMeasurementTemplateQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "measurementTemplateId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "measurementTemplateId",
        "variableName": "measurementTemplateId"
      }
    ],
    "concreteType": "MeasurementTemplate",
    "kind": "LinkedField",
    "name": "measurementTemplate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "dataKind",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "assetKind",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updatePageMeasurementTemplateQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updatePageMeasurementTemplateQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "da1749c78a9c8749fb7ff41d41316909",
    "id": null,
    "metadata": {},
    "name": "updatePageMeasurementTemplateQuery",
    "operationKind": "query",
    "text": "query updatePageMeasurementTemplateQuery(\n  $measurementTemplateId: ID!\n) {\n  measurementTemplate(measurementTemplateId: $measurementTemplateId) {\n    id\n    createdAt\n    name\n    dataKind\n    assetKind\n  }\n}\n"
  }
};
})();

(node as any).hash = "3abbad387ac01bd00d29085a2060bb4e";

export default node;
